import {
	UPDATE_FILTER_LIST,
	RESET_SEARCH_LISTING_DATA,
	SET_LISTING_TABS_COUNT,
	SET_ORDER_LISTING_DATA,
	SET_SEARCH_LISTING_DATA,
	UPDATE_CHECKED_LIST,
	UPDATE_SHIMMER,
	SET_ORDER_DETAILS_DATA
} from '../actions/types';

const initialState = {
	tabsCount: [],
	orderListingData: [],
	pageNo: 1,
	showShimmer: true,
	selectedTabKey: '',
	pageNo: 1,
	checkedListingList: [],
	searchData: [],
	filterList: [],
	orderDetails: {}
};
export default (state = initialState, action) => {
	switch (action.type) {
		case SET_LISTING_TABS_COUNT: {
			const tabsData = action.payload.tabs;
			return {
				...state,
				tabsCount: tabsData
			};
		}
		case SET_ORDER_LISTING_DATA: {
			let oldResultData =
				action.payload.pageNo == 1 ? [] : state.orderListingData;
				
				return {
					...state,
					orderListingData:
						action.payload.error == 1 || !action.payload.order_summary
							? oldResultData
							: oldResultData.concat(action.payload.order_summary),
					allResultsFetched: action.payload.error == 1 ? true: action.payload.order_summary < 10,
					showShimmer: false
				};
			
		}

		case UPDATE_SHIMMER: {
			return {
				...state,
				showShimmer: true,
				selectedTabKey: action.payload
			};
		}
		case UPDATE_CHECKED_LIST: {
			return {
				...state,
				checkedListingList: action.payload
			};
		}
		case SET_SEARCH_LISTING_DATA: {
			let oldResultData =
				action.payload.pageNo == 1 ? [] : state.searchData;
			return {
				...state,
				searchData:
					action.payload.error == 1
						? []
						: oldResultData.concat(action.payload.order_summary)
			};
		}
		case RESET_SEARCH_LISTING_DATA: {
			return {
				...state,
				searchData: []
			};
		}
		case UPDATE_FILTER_LIST: {
			return {
				...state,
				filterList: action.payload
			}
		}
		case SET_ORDER_DETAILS_DATA: {
			return {
				...state,
				orderDetails: action.payload
			}
		}
		default:
			return state;
	}
};
